{ Analytics } = require '@trello/atlassian-analytics'
Auth = require 'app/scripts/db/auth'
Alerts = require 'app/scripts/views/lib/alerts'
Controller = require 'app/scripts/controller'
Dates = require 'app/scripts/lib/dates'
LegacyPowerUps = require 'app/scripts/data/legacy-power-ups'
PopOver = require 'app/scripts/views/lib/pop-over'
Util = require 'app/scripts/lib/util'
View = require 'app/scripts/views/internal/view'
WindowSize = require 'app/scripts/lib/window-size'
_ = require 'underscore'
template = require 'app/scripts/views/templates/date_picker'
{ track, trackUe } = require '@trello/analytics'
{ sendPluginTrackEvent } = require 'app/scripts/lib/plugins/plugin-behavioral-analytics'
moment = require 'moment'
{ Storage } = require '@trello/storage'
l = require 'app/scripts/lib/localize'
{ dontUpsell } = require '@trello/config'
{ featureFlagClient } = require '@trello/feature-flag-client'
React = require 'react'
ReactDOM = require '@trello/react-dom-wrapper'
{ renderComponent } = require 'app/src/components/ComponentWrapper'

CALENDAR_POWER_UP_ID = require('app/scripts/data/legacy-power-ups').calendar

getPikadayStrings = ->
  previousMonth: l('prev month button text')
  nextMonth: l('next month button text')
  months: moment.months()
  weekdays: moment.weekdays()
  weekdaysShort: moment.weekdaysMin()

timeFormat = 'LT'
parseFormat = [timeFormat, 'h:mm A']
isTimeStringValid = (string) -> moment(string, parseFormat).isValid()

# values are in minutes for custom due date reminders
customReminderSettings = -> [
  { name: 'no', text: l('due-date-custom-reminder.none'), value: -1 },                                       # no reminder
  { name: 'at time of due date', text: l('due-date-custom-reminder.at-time-of-due-date'), value: 0 },          # 0 minutes
  { name: '5 minutes before', text: l('due-date-custom-reminder.5-minutes-before'), value: 5 },                # 5 minutes
  { name: '10 minutes before', text: l('due-date-custom-reminder.10-minutes-before'), value: 10 },             # 10 minutes
  { name: '15 minutes before', text: l('due-date-custom-reminder.15-minutes-before'), value: 15 },             # 15 minutes
  { name: '1 hour before', text: l('due-date-custom-reminder.1-hour-before'), value: 60 },                     # 1 hour
  { name: '2 hours before', text: l('due-date-custom-reminder.2-hours-before'), value: 2 * 60 },               # 2 hours
  { name: '1 day before', text: l('due-date-custom-reminder.1-day-before'), default: true, value: 24 * 60 },   # 1 day
  { name: '2 days before', text: l('due-date-custom-reminder.2-days-before'), value: 2 * 24 * 60 }             # 2 days
]

defaultReminder = -> customReminderSettings().find((reminder) => reminder.default).value

module.exports = class DatePickerView extends View
  viewTitleKey: 'change due date'
  tagName: 'form'
  className: 'dpicker-widget u-clearfix'

  events:
    'click .js-remove-date': 'removeDueDate'
    'input .js-dpicker-time-input': 'validateTimeInput'
    'change .js-dpicker-time-input': 'normalizeTimeInput'
    'click a[href="/business-class"]': ->
      track('Card Detail', 'Click Business Class Link', 'Date Picker PopOver')
    'submit': 'onSaveClickHandler'
    'click .js-enable-calendar-powerup': (e) ->
      e.preventDefault()
      @enableCalendarPowerUp()

  initialize: ->
    @listenTo @model.getBoard(), 'change:powerUps', @renderCalendarPowerUp
    @trackViewed()
    @loadPikadayLibrary()

  loadPikadayLibrary: ->
    @pikadayLoadPromise ?= `import(/* webpackChunkName: "pikaday" */'pikaday')`
      .then((library) =>
        @Pikaday = library.default
      )

  getSelectedDueDateMoment: ->
    date = @picker.getMoment()
    if !date.isValid()
      return null

    # Pikaday requires a single date format, and will parse it strictly (which
    # is good). However, this means an entry like '2/14/15' will parse as
    # '02/14/0015', which isn't great.
    if date.year() < 1000
      date.add(2000, 'years')

    time = @selectedTimeMoment()
    date
    .hour time.hour()
    .minute time.minute()

  submitDueDate: (dueDateMoment, reminder) ->
    if dueDateMoment?
      @setDueDate(dueDateMoment.toDate(), reminder)
    else
      @removeDueDate()

  setDueDate: (date, reminder) =>
    @trackSetDueDate(date, reminder)

    DatePickerView.lastDueDate = date
    Storage.set("lastDueDateReminder_#{Auth.myId()}", reminder)

    data = { 'due': date.getTime(), 'dueReminder': reminder }
    if @options.onError?
      @model.update(data, @options.onError)
    else
      @model.update(data)

    daysFromNow = Math.round((date - Date.now()) / Util.getMs({ days: 1 }))

    @model.recordAction
      type: 'set-due-date'
      date: date.getTime()
      reminder: if reminder == -1 then undefined else reminder

    if daysFromNow >= 1
      # We don't know if they're thinking about the due date as a specific date
      # (e.g. Feb 7) or a date relative to today (one week from now) so
      # record both actions
      timeOfDay = Math.round((date - moment(date).startOf('day')) / Util.getMs({ minutes: 1 }))
      @model.recordAction
        type: 'set-due-date'
        days: daysFromNow
        time: timeOfDay
        reminder: if reminder == -1 then undefined else reminder

    PopOver.hide()

    if @shouldEnableCalendar()
      @enableCalendarPowerUp()
      board = @model.getBoard()

      # record when we auto enabled calendar on this board
      board.setPluginDataByKey(CALENDAR_POWER_UP_ID, 'board', 'shared', 'dateAutoEnabled', Date.now())

      sendPluginTrackEvent({
        idPlugin: CALENDAR_POWER_UP_ID
        idBoard: board.id
        idCard: @model.id
        event:
          action: 'autoEnabled'
          actionSubject: 'powerUp'
          source: 'datePickerInlineDialog'
          attributes:
            dueDateCount: @model.getBoard().countDueDates()
            dueDateThreshold: featureFlagClient.get('ecosystem.auto-enable-calendar', 0)
            trackingCategory: @options.trackingCategory
      })

  removeDueDate: ->
    @trackRemoveDueDate()

    if @model.get('due')
      @model.update({ 'due': null, 'dueReminder': -1 })
    PopOver.hide()

  trackSetDueDate: (date, reminder = defaultReminder()) ->
    category = @options.trackingCategory
    context = @trackingContext()

    prepObject = "on card"
    reminderName = customReminderSettings().find((opt) => opt.value == reminder).name
    prepObject = "with #{reminderName} custom notification"

    indObj = if !@model.getDueDate()?
      'that did not have a due date'
    else if @model.getDueDate()?.getTime() == date.getTime()
      'that had the same due date'
    else
      'that had a different due date'

    trackUe(category, 'saves', 'due date', prepObject, indObj, 'by clicking save button in the due date popover', context)

    board = @model.getBoard()
    Analytics.sendTrackEvent({
      action: 'set'
      actionSubject: 'dueDate'
      containers:
        card:
          id: @model.id
        board:
          id: board.id
        organization:
          id: board.get('idOrganization')
      source: 'datePickerInlineDialog'
      attributes:
        trackingCategory: @options.trackingCategory
    })

  trackRemoveDueDate: ->
    category = @options.trackingCategory
    context = @trackingContext()

    trackUe(category, 'removes', 'due date', 'from card', '', 'by clicking remove button in the due date popover', context)

    board = @model.getBoard()
    Analytics.sendTrackEvent({
      action: 'removed'
      actionSubject: 'dueDate'
      containers:
        card:
          id: @model.id
        board:
          id: board.id
        organization:
          id: board.get('idOrganization')
      source: 'datePickerInlineDialog'
      attributes:
        trackingCategory: @options.trackingCategory
    })

  trackViewed: ->
    board = @model.getBoard()
    Analytics.sendScreenEvent({
      name: 'datePickerInlineDialog'
      containers:
        card:
          id: @model.id
        board:
          id: board.id
        organization:
          id: board.get('idOrganization')
      attributes:
        trackingCategory: @options.trackingCategory
    })

  trackingContext: ->
    cardId: @model.id
    boardId: @model.getBoard()?.id
    teamId: @model.getBoard()?.getOrganization()?.id

  renderCalendarPowerUp: ->
    $show = @$('.js-cal-enabled').addClass('hide')
    $cal = @$('.js-enable-cal').addClass('hide')

    board = @model.getBoard()
    calendarEnabled = board.isPowerUpEnabled('calendar')
    showCalendar = board.owned() && !calendarEnabled

    if calendarEnabled
      $show.removeClass('hide')
    else if showCalendar
      $cal.removeClass('hide')
    return

  getSelectReminderSetting: ->
    dueReminder = @model.get('dueReminder')
    reminderSetting = if dueReminder? then dueReminder else Storage.get("lastDueDateReminder_#{Auth.myId()}")
    return if reminderSetting? then reminderSetting else defaultReminder()

  vigor: @VIGOR.NONE
  renderOnce: ->
    board = @model.getBoard()

    defaultDueDate = moment().add(1, 'days').toDate()
    dueDate = @model.getDueDate() ? DatePickerView.lastDueDate ? defaultDueDate

    @$el.html template({
      canChangePowerUps: board.owned(),
      canEnableAdditionalPowerUps: board.canEnableAdditionalPowerUps(),
      upsellEnabled: !dontUpsell
      customReminderSettings: customReminderSettings()
      selectedReminderSetting: @getSelectReminderSetting()
    })

    @loadPikadayLibrary().then =>

      @picker = new @Pikaday
        field: @$('.js-dpicker-date-input')[0]
        container: @$('.js-dpicker-cal')[0]
        bound: false
        format: 'l'
        firstDay: moment.localeData().firstDayOfWeek()
        i18n: getPikadayStrings()
        keyboardInput: false

      @picker.setDate dueDate

      @$timeInput().val moment(dueDate).format(timeFormat)

      @renderCalendarPowerUp()

    @

  validateTimeInput: ->
    @$timeInput().toggleClass 'input-error', !@isTimeInputValid()

  normalizeTimeInput: ->
    @$timeInput().val @selectedTimeMoment().format(timeFormat)
    @validateTimeInput()

  selectedTimeMoment: ->
    if @isTimeInputValid()
      moment(@$timeInput().val(), parseFormat)
    else
      moment().hours(12).minutes(0)

  $timeInput: -> @$('.js-dpicker-time-input')

  isTimeInputValid: -> isTimeStringValid @$timeInput().val()

  enableCalendarPowerUp: ->
    @model.getBoard().enablePlugin(CALENDAR_POWER_UP_ID)
      .catch (err) =>
        @model.getBoard().disablePlugin(CALENDAR_POWER_UP_ID)
        if Util.isJsonString(err.textStatus) && JSON.parse(err.textStatus).error == 'PLUGIN_NOT_ALLOWED'
          Alerts.show('plugin not allowed', 'error', 'addpluginerror', 4000)
        else
          Alerts.show('could not add plugin', 'error', 'addpluginerror', 2000)
    track "Card Detail", "Enable Calendar via Due Date Menu"
    trackUe('card detail', 'enables', 'Power-Up', '', '', 'due date', CALENDAR_POWER_UP_ID)
    return

  onSaveClickHandler: (e) =>
    e.preventDefault()
    dueDateMoment = @getSelectedDueDateMoment()
    reminderVal = parseInt(@$('.js-custom-reminder').val())
    reminderInt = if isNaN(reminderVal) then defaultReminder() else reminderVal
    @submitDueDate(dueDateMoment, reminderInt)

  shouldEnableCalendar: =>
    board = @model.getBoard()

    if board.isPowerUpEnabled('calendar')
      return false
    if !board.canEnableAdditionalPowerUps()
      return false
    if !@model.editable()
      return false
    if board.isEnterpriseBoard() && !board.getEnterprise()?.isPluginAllowed(CALENDAR_POWER_UP_ID)
      return false

    # check the plugin data to see if calendar has been enabled before on this board
    if board.getPluginDataByKey(CALENDAR_POWER_UP_ID, 'board', 'shared', 'dateAutoEnabled', null)
      return false
    # check flag. If flag returns 0, never auto enable calendar
    dueDateThreshold = featureFlagClient.get('ecosystem.auto-enable-calendar', 0)
    if !dueDateThreshold
      return false

    # if flag not 0, check number of cards with due dates against the flag
    if board.countDueDates() < dueDateThreshold
      return false

    return true
